var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.list != null
    ? _c(
        "div",
        { staticClass: "home_banner" },
        [
          _c(
            "swiper",
            { staticClass: "swiper", attrs: { options: _vm.swiperOption } },
            [
              _vm._l(_vm.list, function(item, index) {
                return _c(
                  "swiper-slide",
                  { key: index, staticClass: "like_slide" },
                  [
                    _c("a", {
                      staticClass: "bannerDiv",
                      style: "background-image: url(" + item.ImgUrl + ")",
                      attrs: { href: item.ClickUrl, target: "_blank" }
                    })
                  ]
                )
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "swiper-pagination",
                attrs: { slot: "pagination" },
                slot: "pagination"
              })
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ea4c484", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ea4c484","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/swiper/advertisement.vue
// module id = null
// module chunks = 